import {redirectToLogin} from "./pages/oauthPage";
import {redirectToAckAccess} from "./pages/ackAccess";
import {InputTypes} from "./enums";
import {v4 as uuid} from "uuid";
import App from "./domains/common/components/App";
import React from "react";

/**
 * @typedef HttpResponseOk
 * @type {Object}
 * @property {*} data
 * @property {boolean} ok
 */

/**
 * @typedef HttpResponseError
 * @type {Object}
 * @property {*} statusText
 * @property {boolean} ok
 * @property {string} message
 * @property {*} status
 * @property {array} errors
 */

export const getBackendURL = () => {
  const location = document.location;

  if(location.hostname === 'register.esoft.tech') {
    return `https://register.esoft.tech/backend`;
  }

  if(location.hostname === 'register-stage.esoft.tech') {
    return `https://register-stage.esoft.tech/backend`;
  }

  return `${location.protocol}//${location.hostname}:3010`;
}

export const getRedirectURL = () => {
  const location = document.location;

  return `${location.protocol}//${location.hostname}`;
}

export const getURL = () => {
  return window.location.href;
}

export const getPathAfterBaseUrl = () => {
  const baseUrl = window.location.origin; // автоматически получает текущий протокол + домен + порт
  const currentUrl = window.location.href;

  if (currentUrl === baseUrl || currentUrl === baseUrl + '/') {
    return '/';
  }

  if (currentUrl.startsWith(baseUrl)) {
    return currentUrl.substring(baseUrl.length);
  }

  return null;
};

// url редиректа после авторизации
export const getFParamFromUrl = () => {
  const urlString = window.location.href;
  const url = new URL(urlString);
  const ffValue = url.searchParams.get('f');

  return ffValue;
}

export const getAuthorizeURL = () => {
  const f = getFParamFromUrl();
  const baseURL = `https://${getOauthURL()}/authorize?response_type=code&client_id=${getOauthClientId()}&redirect_uri=${getRedirectURL()}/oauth/callback`;

  return f ? `${baseURL}&state=${f}` : baseURL;
}

export const getOauthURL = () => {
  if(location.hostname === 'register.esoft.tech') {
    return 'oauth2.esoft.tech'
  }

  return 'oauth2-dev.esoft.tech'
}

export const getOauthClientId = () => {
  if(location.hostname === 'register.esoft.tech') {
    return 'prod-register'
  }

  return 'stage-register'
}

/**
 * Обретка успешного ответа
 * @param data
 * @returns {HttpResponseOk}
 */
export const httpResponse = (data) => {
  return {ok: true, data};
}

/**
 * Обертка ответа при ошибке запроса
 * @param error
 * @returns {HttpResponseError}
 */
export const httpResponseError = (error) => {
  if(error?.response?.status === 403) {
    redirectToLogin();
    return;
  }

  if(error?.response?.status === 461) {
    redirectToAckAccess();
    return;
  }

  return {
    ok: false,
    message: error?.response?.data?.message || error?.message || '',
    status: error?.response?.status,
    statusText: error?.response?.statusText || '',
    errors: error?.response?.data?.errors || []
  }
}

/**
 *
 * @param {HTMLCollectionOf<Element | HTMLInputElement>} elements
 */
export const serializeForm = (elements) => {
  const result = {}
  const inputElements = ['input', 'INPUT', 'SELECT', 'select', 'textarea', 'TEXTAREA']

  for (const element of elements) {
    if (!inputElements.includes(element.nodeName))
      continue;

    try {
      const name = element.attributes?.name?.value

      if (element.type === InputTypes.CHECKBOX) {
        result[name] = getCheckBoxValue(element)
      } else if (element.type === InputTypes.TEXTAREA) {

      } else {
        result[name] = element.value;
      }

    } catch (e) {

    }
  }

  return result;
}

export const getCheckBoxValue = (element) => {
  if (element.value === "true")
    return true;

  return false;
};

/**
 *
 * @param func
 * @param delay
 * @return {(function(): void)|*}
 */
export const waitInputComplete = (func, delay) => {
  let timer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(context, args), delay);
  }
}